import { createContext, useContext } from 'react';
import type { ServerContext } from '../server-context';
import type { Region } from '@/types/constants';
import type { Experiment } from '@/types/aggregation/home';

const GlobalContext = createContext<ServerContext>({
    platform: '',
    isDesktop: false,
    isMobile: false,
    isTablet: false,
    isAndroid: false,
    isAndroidWrapper: false,
    isIos: false,
    isIosWrapper: false,
    isXsellWrapper: false,
    isPokerDesktopClient: false,
    isPokerWrapper: false,

    region: '' as Region,
    isLoggedIn: false,
    currentRoute: '',

    featureFlags: {} as Record<string, true>,
    experiments: {} as Experiment,
    launcherUrlResolution: {
        shouldUseSameDomainLauncher: false,
        isGameWindowV3Enabled: false,
        gamePlayPath: '/game-play'
    },
    isSiteWideJackpotEnabled: false,
    hideSwjTickers: false,
    swjTickerRedesignVariant: undefined
});

export const GlobalProvider = ({ value, children }: { value: ServerContext; children: React.ReactNode }) => {
    return <GlobalContext value={value}>{children}</GlobalContext>;
};

export const useGlobalContext = () => {
    const context = useContext(GlobalContext);
    if (!context) {
        throw new Error('useGlobalContext must be used within an GlobalProvider');
    }
    return context;
};
